/**
 * AdminSegurancaConsolidatedPage — Consolidated Security (Permissões + Políticas)
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AdminConsoleLayout } from '../components/AdminConsoleLayout';
import { AdminPermissionsPage } from './AdminPermissionsPage';
import { AdminSecurityPage } from './AdminSecurityPage';

export const AdminSegurancaConsolidatedPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') ?? 'permissoes';

  return (
    <AdminConsoleLayout>
      <div className="h-full overflow-auto">
        {activeTab === 'permissoes' && <AdminPermissionsPage />}
        {activeTab === 'politicas' && <AdminSecurityPage />}
      </div>
    </AdminConsoleLayout>
  );
};
